<script lang="ts">
  import Simple from "$app/Layouts/Simple.svelte"
  import Plans from "./Plans.svelte"

  import business_logo1 from "@images/companies/cba.png"
  import business_logo2 from "@images/companies/cfg-logo.png"
  import business_logo3 from "@images/companies/accutrans.png"
  import business_logo4 from "@images/companies/classic-plan.png"
  import business_logo5 from "@images/companies/horizon-hobby.png"
  import business_logo6 from "@images/companies/prevost.png"

  interface Props {
    stripe_products?: any[]
  }

  let props = $props()
  let { stripe_products = [] }: Props = props
</script>

<Simple {...props}>
  <div class="relative bg-white">
    <div class="max-w-7xl mx-auto pt-12 px-4 sm:px-6 lg:px-8">
      <h2
        class="text-3xl text-center font-extrabold text-gray-900 sm:text-4xl sm:leading-none sm:tracking-tight lg:text-5xl"
      >
        Our Plans
      </h2>
      <p class="max-w-3xl mx-auto mt-6 text-2xl text-center text-gray-800">
        Get started with our <span class="font-bold">Free Plan</span> or unlock
        the full power of the
        <span class="text-lwp-blue font-semibold">Lead With Platform</span> with
        our
        <span class="font-bold">Standard Subscription</span>.
      </p>
    </div>

    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Plans products={stripe_products} />
    </div>
  </div>

  <div class="bg-white">
    <div class="max-w-7xl mx-auto py-16 px-4 sm:py-20 sm:px-6 lg:px-8">
      <h2 class="text-3xl font-extrabold text-black text-center">
        Loved by Thousands of Businesses
      </h2>
      <div class="mt-12 lg:mt-16">
        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mt-6">
          <div class="flex justify-center items-center">
            <img src={business_logo1} class="mx-auto max-h-16 w-auto" alt="" />
          </div>
          <div class="flex justify-center items-center">
            <img src={business_logo2} class="mx-auto max-h-16 w-auto" alt="" />
          </div>
          <div class="flex justify-center items-center">
            <img src={business_logo3} class="mx-auto max-h-16 w-auto" alt="" />
          </div>
          <div class="flex justify-center items-center">
            <img src={business_logo4} class="mx-auto max-h-12 w-auto" alt="" />
          </div>
          <div class="flex justify-center items-center">
            <img src={business_logo5} class="mx-auto max-h-10 w-auto" alt="" />
          </div>
          <div class="flex justify-center items-center">
            <img src={business_logo6} class="mx-auto max-h-16 w-auto" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</Simple>
